/* eslint-disable better-mutation/no-mutation */

/**
 * Inject a script in the head with given text content
 *
 * @param {string} text
 * @param {object} [attributes]
 * @returns {HTMLElement} - The injected script element
 */
function injectScript(text, attributes) {
    const scriptElement = document.createElement('script');
    Array.from(Object.entries(attributes)).forEach(([name, value]) => {
        scriptElement.setAttribute(name, value);
    });
    scriptElement.appendChild(document.createTextNode(text));
    document.head.appendChild(scriptElement);
    return scriptElement;
}

function loadScript(src, options = {}) {
    const optionsWithDefaults = {
        timeout: options.timeout || 0
    };
    return new Promise((resolve, reject) => {
        if (document.querySelector(`head > script[src="${src}"]`) !== null) {
            resolve();
            return;
        }

        const script = document.createElement('script');

        let timeoutTimer;
        if (optionsWithDefaults.timeout > 0) {
            timeoutTimer = setTimeout(() => {
                script.onload = null;
                script.onerror = null;
                document.head.removeChild(script);
                reject(new Error('SCRIPT_LOAD_TIMEOUT'));
            }, optionsWithDefaults.timeout);
        }

        script.src = src;
        script.async = true;
        script.onload = () => {
            if (timeoutTimer) clearTimeout(timeoutTimer);
            resolve();
        };
        script.onerror = error => {
            if (timeoutTimer) clearTimeout(timeoutTimer);
            reject(error);
        };
        document.head.appendChild(script);
    });
}

export { injectScript, loadScript };
